import React, { memo } from "react";
import useLandingPage from "./index.hooks";
import {
  HomeSection,
  HeroSection,
  HowItWorksSection,
  ServicesSection,
  Header,
  Footer,
} from "components";
import { CssBaseline } from "@material-ui/core";
import HeroSections from "models/HeroSections";

type LandingPageProps = {};

const LandingPage = ({}: LandingPageProps) => {
  const { styles } = useLandingPage();

  return (
    <div>
      <CssBaseline />
      <Header />
      <HomeSection />
      {HeroSections.data.map((section) => {
        return <HeroSection key={section._id} {...section} />;
      })}
      <HowItWorksSection />
      {/* <ServicesSection /> */}
      {/* <Footer /> */}
    </div>
  );
};

export default memo(LandingPage);
